import React, {Component} from 'react';
import PropTypes from 'prop-types'

export default class Accordion extends Component {

    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.array
    }

    render() {
        const {className} = this.props;
        return (
            <div className={`accordion ${className}`}>
                {this.props.children}
            </div>
        )
    }

}
